import SystemUserFactory from "./SystemUserFactory";
export default SystemUserFactory;
